export default {
  'recall.response.rejected': 'Rejected',
  'recall.response.accepted': 'Accepted',
  NOOR: 'The associated transaction (SCTR) was not received',
  ARDT: 'the associated transaction has already been returned',
  AC04: 'the associated account is closed',
  NOAS: `the beneficiary didn't answer`,
  CUST: `the beneficiary rejected the recall`,
  AM04: `the beneficiary has insufficient funds`,
  LEGL: `legal decision (frozen assets)`,
  'recall.status.PENDING': `Pending`,
  'recall.status.ACCEPTED': 'Accepted',
  'recall.status.REJECTED': 'Rejected',
  'recall.status.CANCELED': 'Canceled',
  'recall.status.IN_ERROR': 'In error',
  'recall.status.PENDING_ANSWER_REQUESTED': 'Response pending',
  'recall.status.PENDING_PAYIN_REFUND_CREATED': 'Payin refund pending',
};
